import { Component, inject, Input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilizationModal } from '../../../utilization/components/utilization-modal/utilization-modal.component';

@Component({
  selector: 'app-navbar',
  imports: [RouterModule, FormsModule, FontAwesomeModule, NgbDropdownModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  private readonly modalSrv = inject(NgbModal);

  faArrowLeft = faArrowLeft;
  faSearch = faSearch;

  searchTerm: string = '';

  @Input() navList: { label: string, routePath: string, loading?: boolean }[] = [];
  @Input() createButton: 'show' | 'hide' | 'disabled' = 'hide';
  @Input() entityName: string = '';

  @Input() search: boolean = false;
  @Input() searchPlaceholder: string = $localize`Cerca...`;

  @Input() filters: { label: string, value: string, selected: boolean }[] = [];
  @Input() filterButtonPlaceholder: string = $localize`Filtro`;

  @Input() helperQuotaRequest: boolean | null = false;

  searchEvent = output<any>();
  filterEvent = output<string[]>();

  onDropdownChange(openChangeEvent: boolean): void {
    if (openChangeEvent === false) {
      const selected = this.filters
        .filter(opt => opt.selected)
        .map(opt => opt.value);

      console.debug('Selected options:', selected);
      this.filterEvent.emit(selected);
    }
  }

  openUtilizationModal() {
    const modalRef = this.modalSrv.open(UtilizationModal, { centered: true, windowClass: 'qai-modal', size: 'lg' });
    modalRef.result.then(
      (result: { motivation: string }) => {
        console.debug(`Closed with: ${result}`);
      },
      (reason) => {
        console.debug(`Dismissed`);
      },
    );
  }

  isAllFiltersSelected(): boolean {
    return this.filters && this.filters.length > 0 && this.filters.every(filter => filter.selected);
  }

  selectAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (this.filters && Array.isArray(this.filters)) {
      this.filters.forEach(filter => filter.selected = checked);
    }
  }
}
